import { render, staticRenderFns } from "./TheChallengeScoreboard.vue?vue&type=template&id=9ac0250a&"
import script from "./TheChallengeScoreboard.vue?vue&type=script&lang=js&"
export * from "./TheChallengeScoreboard.vue?vue&type=script&lang=js&"
import style0 from "./TheChallengeScoreboard.vue?vue&type=style&index=0&id=9ac0250a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports